// 2026 preseason tape desk.
// Sourced from Kyle Teichmann's ranking videos and AJ Krow's YouTube
// reaction pods, week of Aug 19–26 2026. The board is complete. Do not
// treat Teich's keeper guesses as official. Bach's 5.0% model line was
// confirmed by Kyle after the Grinders tape; he forgot to say the number
// on camera. Kyle later reported Doster's model line at 6.9%. AJ's 7.3%
// tape was split in two because it ran long — same ranking. Anna is
// 20.99%. Kyle put himself first at 50.01%.

export const TAPE_DESK = {
  seriesTitle: 'The Tape',
  modelName: 'Teichmann Predictive Model',
  dissentName: 'Krow Live Reaction',
  dissentLine: 'No surprise he put himself first. I would have done the same.',
  teich: 'Kyle Teichmann',
  krow: 'AJ Krow',
  asOfLabel: 'Week of Aug 26, 2026',
  publishedCount: 10,
  remainingCount: 0,
  boardComplete: true,
};

export const TAPE_RANKS = [
  {
    rank: 10,
    manager: 'Josh',
    teamName: 'Daddy',
    teichPct: '0.0%',
    teichStatus: 'published',
    krowStatus: 'published',
    headline: 'Daddy opens the board.',
    teich: 'Kyle put Josh last with a model line of 0.0%. He almost gave the spot to Samuel on career winning percentage, then decided fantasy is not just the numbers, and the 10-spot has always belonged to Daddy. The receipts: one title-game loss talked about like a ring, last year\'s Cheekwood no-show, and a 2025 roster that had Josh Allen, Christian McCaffrey, and Jonathan Taylor and still missed the playoffs.',
    krow: 'AJ smashed the agree button. He called Josh the worst kind of bad owner: statistically bad, loud anyway, still living off one finals appearance. The Cheekwood "concert" is now canon. Draft weekend, he said, should give Daddy the business.',
    exhibits: [
      'Teich model: 0.0% to win 2026',
      '2025: Allen, CMC, and Taylor on the same roster, no playoffs',
      'Missed the 2025 draft for a Cheekwood event that was not a real concert',
    ],
  },
  {
    rank: 9,
    manager: 'Robby',
    teamName: "Commissioner's Army",
    teichPct: '1.4%',
    teichStatus: 'published',
    krowStatus: 'published',
    headline: 'The Commish is spread too thin.',
    teich: 'Kyle called this a predictive board, not a lifetime ranking, then put Robby at 1.4%. Job, house, relationships, commissioner duties: the bit is that Robby wins when he has one thing to think about. He also had no first-round pick. Kyle\'s pre-draft math assumed Robby would keep nobody. The completed record says otherwise: Robby kept Colston Loveland in round fifteen. The prediction remains on file.',
    krow: 'AJ treated it like a Kawhi investigation: nobody can prove the weird stuff, which is exactly why it feels weird. He walked year-by-year, landed on the 107-point 2025 title-game loss, and took the under on 6.5 wins. Homeowner drop, no first-rounder, and he did not buy the early-keeper push. His keeper, he said, lands at the last minute.',
    exhibits: [
      'Teich model: 1.4% to win 2026',
      'No 2026 first-round pick (Kevin owns it)',
      '2025 championship: Anna 214.83, Robby 107.47',
    ],
  },
  {
    rank: 8,
    manager: 'Ryan',
    teamName: "Rhino's Bunz",
    teichPct: '2.6%',
    teichStatus: 'published',
    krowStatus: 'published',
    headline: 'The Bunts at eight.',
    teich: 'Kyle opened with a PR warning, then dropped the gracious host at 2.6%. He renamed them the Bunts: good enough not to sit with the basement, never actually threatening. Win three, lose three. He called the AI website a thing of the past, guessed the keep is Trey McBride, and said they are not a road team — public Wi-Fi, TSA laptop, already looking at Saturday flights out of Highland Park. Keep paying the entry fee.',
    krow: 'AJ said the Buns usually get mentioned with reluctance. Kyle took a blowtorch to the PR campaign. The comparison was Jared Goff: fine at home, fold in the elements. AJ would not have put Ryan eighth. He likes the Buns in a meaty 5–7, probably sixth, and above the Grinders. The ceiling line: a 1930s ranch house. He does not see a championship. He does respect Kyle for going somewhere the group chat would not.',
    exhibits: [
      'Teich model: 2.6% to win 2026',
      '2024 regular-season champion, still zero rings',
      'AJ would rank the Buns around 6, not 8',
      'Kyle keep guess: Trey McBride — his take, not a locked choice',
    ],
  },
  {
    rank: 7,
    manager: 'Amir',
    teamName: 'Deportivo De La Amir',
    teichPct: '2.7%',
    teichStatus: 'published',
    krowStatus: 'published',
    headline: 'A first-round pick is on the table.',
    teich: 'Kyle filmed #7 from a closet "so we have something in common." 2.7%, barely over the Buns. He called Amir the league\'s random-running-back assassin who also falls in love with terrible quarterbacks. The keep guess is Tyler Warren. Then the wager: if both of Kyle\'s kids can understand every word of Amir\'s reply, Kyle owes a first-round pick.',
    krow: 'AJ held court on the wager. No chain of evidence, no ruling body for "understood," unclear how many times the kids watched it. He is fine with the answer being no. He also asked the Belichick question: has the league passed Kyle, or is this an Andy Reid year? Amir\'s reply tape stayed under a minute and called Kyle\'s identity crisis: one year the lungs, one year the Chumps.',
    exhibits: [
      'Teich model: 2.7% to win 2026',
      'Daughter Merritt, on tape: she could not understand Amir\'s video',
      'Amir: if these rankings go like Kyle\'s 2025 draft, Deportivo feels fine',
    ],
  },
  {
    rank: 6,
    manager: 'Samuel',
    teamName: 'The Maestro',
    teichPct: '3.1%',
    teichStatus: 'published',
    krowStatus: 'published',
    headline: 'Sam, on purpose.',
    teich: 'Fifth video, sixth-best chance. Kyle\'s model: 3.1%. Samuel wins 42% of matchups, second-lowest all-time, owns all his picks, and has a pile of keeper choices: Dak in the fourth, Caleb in the sixth, Dart in the 14th, Achane in the third, Egbuka in the eighth. Kyle thinks he is trending up. That is the whole video. He even said it was short on purpose.',
    krow: 'AJ\'s dedicated pod: "Is the PRESSURE Getting To Teich?" He called Kyle calling him Sam, not the Maestro, a subtle dig. He thinks Samuel keeping Caleb was the right call over Dart in the 14th. Then the meta: the bottom of the board was easy; creating the tape is the hard part. Bottom is easy. Daddy, JG, Qureshi — easy. Rhino\'s bots made Kyle shaky. Bach is still unranked. Remaining names AJ expects in some order: Teich, AJ, Anna, and Bryan. His guess: Anna at one.',
    exhibits: [
      'Teich model: 3.1% to win 2026',
      'Kyle said Sam, not the Maestro',
      'AJ: Caleb over Dart is the right keep, still not a locked league fact',
      'AJ will go live Tuesday mornings once the season starts',
    ],
  },
  {
    rank: 5,
    manager: 'Kevin',
    teamName: "Grundle's Grinders",
    teichPct: '5.0%',
    teichStatus: 'published',
    krowStatus: 'published',
    headline: 'A Grinders lovefest, allegedly.',
    teich: 'Kyle finally got to Bach. Toilet of the league, dry-draft documentary, a thousand dollars for the AJ-Kevin dinner transcript, then the plot twist: we are all in on the Grinders this year. Loaded draft capital. Keeper guesses: Rasheed Rice in the 10th or Skattebo in the 13th — his take, not a locked choice. Twelve guys on the roster before most starting lineups are filled. Russell Wilson: a legit ring, relocated, Mr. Limited in Northwest Arkansas. First drink is on Kyle. After that they are pumping him full all weekend. Career win rate, Kyle says, is 40%, worst in league history. The model line is 5.0%. He forgot to say the percent on camera and confirmed it after.',
    krow: 'AJ\'s pod: "Teich and Grinders LOVEFEST???" He was not surprised Bach was the choice. He was surprised by the why. Mickey Mouse title, but a title. Then the conspiracy desk: Grinders beat Team Teichmann, so Teich benefits from a Bach-is-better campaign. Dry draft up front to throw people off the scent, then a net-positive video. AJ would not have Bach this high. Follow the breadcrumbs.',
    exhibits: [
      'Teich model: 5.0% to win 2026 (Kyle confirmed after the tape; he forgot to say it)',
      'Kyle: 40% career win rate, lowest in league history — his number',
      'Kyle keep guesses: Rice 10th or Skattebo 13th — his take, not locked',
      'AJ: would not have Bach this high',
      'Kevin answered on tape: the dry draft is a story Teich spoke into existence',
    ],
  },
  {
    rank: 4,
    manager: 'Bryan',
    teamName: 'Better Managed',
    teichPct: '6.9%',
    teichStatus: 'published',
    krowStatus: 'published',
    headline: 'Doster, the tough out.',
    teich: 'Kyle put Doster fourth with a 6.9% likelihood to win, opening the top four. AJ\'s reaction desk is the public copy of that tape: Teich nailed it. Sticks to the board. Always a good team nobody expects. Takes guys a round early and they hit. Teich also said Doster does not want the spotlight. AJ called that the one unnecessary shot.',
    krow: 'AJ\'s pod ran under five minutes because there was not much else to say. "Teich NAILS Doster\'s Ranking???" Perennial tough out. PE guy, car washes, disciplined investor: not emotion, the model. If Doster wins the league every year that is a tax burden. This is covering payroll, a diversification play, not a fear of the lights. He bounces before the actual draft. He never misses hoops or anything with a number. Most underrated manager in the league. Cannot go lower. Cannot go higher. If Doster is in the final, the content desk has a problem.',
    exhibits: [
      'Teich model: 6.9% to win 2026',
      'Kyle slotted Doster fourth, into the top four',
      'AJ: cannot put him lower or higher than this',
      'AJ: covering payroll. If he wins, that is a tax problem',
    ],
  },
  {
    rank: 3,
    manager: 'A.J.',
    teamName: 'Highland Park Hitmen',
    teichPct: '7.3%',
    teichStatus: 'published',
    krowStatus: 'published',
    headline: 'Third. High variance, on purpose.',
    teich: 'Kyle filmed this one in two parts because it ran long. Same ranking: AJ third, 7.3%. Pickleball court, draft week, paddles on Friday. Positives first: Kyle calls him a two-time champ (inaugural year plus 2021), says the trophy case listing one ring is wrong, and tells Ryan to fix the website. Eye for talent. Scarcity, regression, positional value. Good roster. Content bump. Host bump. Keeper guesses: T-Law, Drake, or JSN in the third — his takes, not locked. Then the plot: this is a bit, except AJ is too far gone to know where the joke stops. Never wrong, just early. He started to believe it. Got cute last year. He does not just want to win. He wants to win and start a crazy quarterback. He wants to win and burn a pick. Kyle said he could not wait for the live reaction. He got it. He thought this one was fair.',
    krow: 'AJ\'s pod: "Teich TAKES ON The Hitmen." He did not go unhinged. Third is reasonable — top three, four. High-variance club: championship or last, never a 9-8. Last year, he says, he had the best team and sat Trevor Lawrence on purpose. Would have won anyway. After two titles it is about how you win, not whether. Quinn Ewers. One hand behind his back. Almost yes. JSN in the third or Drake May in the seventh are options. The keep waits. Remaining: Teich and Anna.',
    exhibits: [
      'Teich model: 7.3% to win 2026',
      'Kyle split the tape in two because it ran long — one manager',
      'Kyle keep guesses: T-Law, Drake, or JSN in the 3rd — his takes',
      'Kyle: two-time champ. He told Ryan to fix the website — the 2013 ring is on the ledger now',
      'AJ: third is reasonable. High-variance club: championship or last',
      'AJ: sat T-Law on purpose last year and still would have won — his take, not a ledger rewrite',
      'AJ keep options: JSN in the 3rd or Drake May in the 7th — not locked',
      'AJ: remaining names Teich and Anna',
    ],
  },
  {
    rank: 2,
    manager: 'Anna',
    teamName: 'Phemale Phenom',
    teichPct: '20.99%',
    teichStatus: 'published',
    krowStatus: 'published',
    headline: 'The Phenoms at two.',
    teich: 'Kyle filmed this one from the kitchen. 20.99%, a jump from the Ghosts at 7.3%. Back-to-back titles, three total, almost a fourth. Nobody has gone three in a row, and he is not going to pretend otherwise. He respects the drafting: set it and forget it, durable players, no tinkering, no trades, maybe never a waiver dollar. Then the keep guesses — his takes, not locked: Stafford in the 12th at 38, Pickens in the 7th, Bijan in the first. He wants her to choose her draft slot. Two league members already told him no to his face. Close with the family. They modeled the early years on Teichmann, he says. The bombshell, in his words: the Amir situation, now that it is out. Sexual tension in the group chat. If anybody can move past it, it is her. Michael Jordan energy. That is why the two-slot is respect.',
    krow: 'AJ\'s pod: "Teich SHOWS His Hand???" Phenoms up. He addressed Tish first. Strange behavior: campaigning for Anna to pick her draft spot after she missed, after she won last year — AJ says — because he sat Trevor Lawrence. League office and the Phenoms, and now Team Tish in the light too. People call him a sore loser who makes stuff up. He said he would let the data talk. Toughest slate, conspiracy, three titles of his own — his claim, not a ledger rewrite. Luckiest. Ignore him at your own peril.',
    exhibits: [
      'Teich model: 20.99% to win 2026',
      'Kyle: back-to-back titles, three total. The 2025 ledger lists Anna as champion',
      'Kyle keep guesses: Stafford 12th, Pickens 7th, Bijan 1st — his takes, not locked',
      'Kyle: she should get to choose her draft slot. Two members already told him no',
      'Kyle: the Amir situation is the downfall theory. If anybody can move past it, it is her',
      'AJ: Teich showed his hand. League office, Phenoms, and now Team Tish',
      'AJ: she won last year because he sat T-Law — his take, not a ledger rewrite',
    ],
  },
  {
    rank: 1,
    manager: 'Kyle',
    teamName: 'Quest for Ring #4',
    teichPct: '50.01%',
    teichStatus: 'published',
    krowStatus: 'published',
    headline: 'He anoints himself.',
    teich: 'Tenth day, tenth location, parked car. He told people to stop filming while driving. Then the backlash bit: how is Anna two? Her three titles equal his three titles. Did you think he would make ten videos and not put himself first? Three championships, most all-time. Five title-game appearances, most all-time. 11-5 in the playoffs. The website, he says, just made the dominance obvious. Keep guess: Chris Olave in the 11th. Eleven picks in the first eight rounds, Olave on top of that, twelve bodies after round eight. The model line is 50.01%. More likely he wins than he does not. He wants 16-0 and every weekly high. Extra 24 hours because draft order is Friday. Dynasty title last year, work league too. Buyers at the deadline, maybe after, Robby versus the NCAA. 2027 picks can wait until round 10. Villain on purpose. Alpha. Disciples is too far. Quote: he is not just a key piece of this league. "I am the league."',
    krow: 'AJ\'s finale: "Teich ANNOINTS Himself." No surprise. He would have done the same thing. Ten videos in ten days, and he will not hate on the work. Content 101, in AJ\'s read: invent a narrative nobody is arguing and argue it. The rankings are Kyle\'s; he can put himself first. The concern is who programmed the model. Bias. Ryan could help with the prompts. Target on the back. Belichick: still-got-the-fastball, or Chapel Hill Bill? Challenge: be good this year. Rising tide. Three titles, it has been a while, does the logo still mean anything. Kyle wants to be the villain. AJ does not think he has been one for years. That is Tish, whatever. Extra day of prep. Maybe freewheel it. Tuesday mornings once the season starts.',
    exhibits: [
      'Teich model: 50.01% to win 2026 — more likely he wins than he does not',
      'Kyle: three championships and five title-game appearances, both most all-time — his count, and it matches the ledger',
      'Kyle keep guess: Chris Olave in the 11th — his take, not locked',
      'Kyle: 11 picks in the first eight rounds, then Olave, twelve bodies after round eight',
      'Kyle: extra 24 hours because draft order is Friday. Buyers at the deadline',
      'AJ: no surprise. He would have done the same thing',
      'AJ: bias in the model. Belichick — fastball or Chapel Hill Bill',
      'AJ: Kyle has not been the villain in years. That is Tish, whatever',
    ],
  },
];

export const PENDING_RANKS = [];

// Board is complete as of the Aug 26 finale. Kept so HomeFilm can hide the camera bag.
export const PENDING_TEASER = '';

export const COURT_CASES = [
  {
    docket: 'B09-2026-01',
    title: 'The Cheekwood Affair',
    defendant: 'Josh',
    charge: 'Missing the 2025 draft for a Cheekwood event that was not, in fact, a concert.',
    exhibit: 'Both Kyle and AJ entered it as league canon. AJ: the league has let him off the hook too long.',
    status: 'Open',
    recommendedSentence: 'Unspecified business at draft weekend.',
  },
  {
    docket: 'B09-2026-02',
    title: 'The 107-Point Final',
    defendant: 'Robby',
    charge: 'Putting up 107.47 in the 2025 championship and still being discussed like a perennial finalist.',
    exhibit: 'Anna 214.83, Robby 107.47. Second-largest title-game margin on the ledger. AJ called the real-champion talk a clerical error.',
    status: 'On the record',
    recommendedSentence: 'The under on 6.5 wins, per the reaction desk.',
  },
  {
    docket: 'B09-2026-03',
    title: 'State of Teichmann v. Qureshi',
    defendant: 'Kyle',
    charge: 'Wagering a first-round pick on whether his children understood every word of Amir\'s video.',
    exhibit: 'Merritt, on tape: "No." Follow-up: stranger danger and run. AJ: no chain of evidence, but he is okay with no.',
    status: 'Provisional ruling',
    recommendedSentence: 'Kyle keeps the pick. The clip stays in the museum.',
  },
  {
    docket: 'B09-2026-04',
    title: 'The Mickey Mouse Title',
    defendant: 'Kevin',
    charge: 'Possessing the 2023 championship, which the reaction desk has reclassified as a COVID bubble ring.',
    exhibit: 'Kevin won 2023 by 5.30 points, then went 2-12 and 2-12. AJ: nobody actually pays attention to it.',
    status: 'Appeals closed',
    recommendedSentence: 'The ring stays in the trophy case. The nickname stays in the group chat.',
  },
  {
    docket: 'B09-2026-05',
    title: 'The Dry Draft',
    defendant: 'Kevin',
    charge: 'Allegedly staying sober at the 2025 draft while Kyle treats it like the crime of the century.',
    exhibit: 'Kyle wants a documentary. Kevin: Teich manifested it, and he is not taking drinking notes from Kyle Teichmann. AJ: the dry-draft open is bait so the lovefest sticks.',
    status: 'He said / he said',
    recommendedSentence: 'First drink on Kyle. After that, Kevin\'s call.',
  },
  {
    docket: 'B09-2026-06',
    title: 'The Payroll Cover',
    defendant: 'Bryan',
    charge: 'Treating the Brentwood Bruins as a cash-flow diversification play and bouncing before the actual draft.',
    exhibit: 'AJ: he does not miss hoops or anything with a number. He probably misses the draft. If he wins, that is a tax problem. If he is in the final, that is a content problem.',
    status: 'Admired, alleged',
    recommendedSentence: 'Keep the model. Show up for the numbered events. The hoop session is already locked.',
  },
  {
    docket: 'B09-2026-07',
    title: 'The Win-And',
    defendant: 'A.J.',
    charge: 'Wanting to win, and also start a crazy quarterback, and also burn a splashy pick.',
    exhibit: 'AJ, on the Hitmen pod: after two titles it is not about a third, it is about how. Sat T-Law. Quinn Ewers. One hand behind his back. Almost yes. The 2025 ledger still lists Anna as champion.',
    status: 'Defendant testified',
    recommendedSentence: 'He is not coming back to earth. That was the point.',
  },
  {
    docket: 'B09-2026-08',
    title: 'The Draft-Slot Privilege',
    defendant: 'Kyle',
    charge: 'Campaigning for Anna to choose her draft slot after two league members already told him no to his face.',
    exhibit: 'Kyle, on the Phenoms tape: she has earned the privilege. AJ\'s pod: Teich SHOWS His Hand. League office, Phenoms, and now Team Tish.',
    status: 'Two votes of no, on the record',
    recommendedSentence: 'The slot stays in the competition. The campaign stays in the museum.',
  },
  {
    docket: 'B09-2026-09',
    title: 'The Self-Anointing',
    defendant: 'Kyle',
    charge: 'Putting himself first at 50.01% and declaring that he is the league.',
    exhibit: 'Tenth video, parked car. AJ: no surprise, he would have done the same. Belichick question: fastball or Chapel Hill Bill. Extra day of prep because draft order is Friday.',
    status: 'Finale aired',
    recommendedSentence: 'The one-slot is his. The 16-0 talk is evidence.',
  },
];

export const FRANCHISES = [
  {
    manager: 'A.J.',
    current: 'Highland Park Hitmen',
    lineage: ['Dallas Deviants', 'Dallas DPs', 'Glendive Ghosts', 'Highland Park Hitmen'],
    note: 'On the board at three at 7.3%. Kyle split the tape because it ran long. AJ\'s reaction: third is reasonable, high-variance on purpose, settled in Highland Park with a stadium going up. Relocation still stands: Glendive could not close the stadium deal, so the Ghosts moved to Highland Park.',
  },
  {
    manager: 'Kyle',
    current: 'Quest for Ring #4',
    lineage: ['Burn the Boats', 'RobTop Kevin Bottom', "Teichmann's Revenge", 'Cheekwood Chumps', 'Quest for Ring #4'],
    note: 'On the board at one at 50.01%. Tenth day, parked car, Olave in the 11th. Amir\'s earlier counter-tape: one year it\'s the lungs, one year it\'s the Chumps. AJ\'s finale: no surprise he anointed himself. Belichick question still open.',
  },
  {
    manager: 'Anna',
    current: 'Phemale Phenom',
    lineage: ['Phemale Phenom'],
    note: 'On the board at two at 20.99%. Three titles, back-to-back in 2024 and 2025. Kyle wants her to pick her draft slot. AJ: Teich showed his hand.',
  },
  {
    manager: 'Josh',
    current: 'Daddy',
    lineage: ['Daddy'],
    note: 'Josh offered Kyle three replacement names: Daddy Issues, Identity Crisis, or The Chodes. The offer is one-way.',
  },
  {
    manager: 'Ryan',
    current: "Rhino's Bunz",
    lineage: ["Rhino's Bunz"],
    note: 'AJ: plenty of conversation about the Buns as a host and a gym. Almost none about the Buns as a football team.',
  },
  {
    manager: 'Kevin',
    current: "Grundle's Grinders",
    lineage: ["Grundle's Grinders"],
    note: 'On the board at five at 5.0%. Kyle: Russell Wilson, Mr. Limited, Northwest Arkansas. Kevin\'s rebuttal: the sober-draft story is fake news Teich spoke into existence, and Dallas is game on.',
  },
  {
    manager: 'Bryan',
    current: 'Better Managed',
    lineage: ['Better Managed'],
    note: 'Doster. Ranked fourth at 6.9%. AJ: most underrated manager in the league, PE guy, car-wash investor, sticks to the board. Bounces on draft night, never misses hoops.',
  },
  {
    manager: 'Robby',
    current: "Commissioner's Army",
    lineage: ['Lost on Purpose', "Commissioner's Army"],
    note: 'Historical ruling: Robby drafted Lost on Purpose in 2017; finishing Hatley\'s after Blake\'s passing was a caretaker role, not a franchise transfer. Kyle: great at organizing, mass texts, and collecting money. Not, in this model, a threat to win.',
  },
];

export const SEALED_TAKES = [
  { speaker: 'Kyle Teichmann', text: 'Josh has a 0.0% chance to win the league this year.' },
  { speaker: 'AJ Krow', text: 'Daddy is the worst kind of bad owner, because statistically he is really bad and still the loudest.' },
  { speaker: 'Kyle Teichmann', text: 'Robby: 1.4%. Life is hard. Owning a house is a challenge. He is not handling this well.' },
  { speaker: 'Kyle Teichmann', text: 'Number eight. 2.6% chance to win. It\'s the Bunts. Keep paying that entry fee.' },
  { speaker: 'AJ Krow', text: 'The Buns ceiling is a 1930s ranch house. I do not ever see them in a championship.' },
  { speaker: 'Kyle Teichmann', text: 'If every word in Amir\'s video can be understood by my two children, I will give him my first-round pick.' },
  { speaker: 'AJ Krow', text: 'Kevin\'s title is a Mickey Mouse, COVID-bubble championship. I do not think anybody actually pays attention to it.' },
  { speaker: 'AJ Krow', text: 'You will know my keeper at the very last minute, because that is what strategy is.' },
  { speaker: 'Josh', text: 'Objectively, Teich has something going on for me. I have three suggestions for a new team name.' },
  { speaker: 'AJ Krow', text: 'He did not call him the Maestro. I thought that was a very subtle dig.' },
  { speaker: 'AJ Krow', text: 'Could have gone Dart for a 14th, but do you trust it? I think Sam made the right decision with Caleb.' },
  { speaker: 'AJ Krow', text: 'The bottom is easy. He will probably put Anna number one.' },
  { speaker: 'AJ Krow', text: 'Historically Teich is one of the all-time greats at the reaction. The question is whether he can create.' },
  { speaker: 'Kyle Teichmann', text: 'Plot twist. We\'re all in on the Grinders this year. They are a contender.' },
  { speaker: 'Kyle Teichmann', text: 'Bach is Russell Wilson. Ring early, relocates, can\'t get it done. Mr. Limited, Northwest Arkansas.' },
  { speaker: 'AJ Krow', text: 'I would not have Bach up this high.' },
  { speaker: 'AJ Krow', text: 'Why would Teich launch a campaign that the Grinders are better than people think?' },
  { speaker: 'Kevin', text: 'I couldn\'t believe I was getting shit from Kyle Teichmann for not drinking enough.' },
  { speaker: 'Kyle Teichmann', text: 'Bach is 5.0%. I forgot to say the percent on the tape.' },
  { speaker: 'AJ Krow', text: 'I thought Teich nailed this one. Doster is just perennially a tough out.' },
  { speaker: 'AJ Krow', text: 'I don\'t think you can put Doster any lower than this. I agree with Teich that I don\'t think you can put him any higher.' },
  { speaker: 'AJ Krow', text: 'Doster, the most underrated manager in the league.' },
  { speaker: 'Kyle Teichmann', text: 'Doster has a 6.9% likelihood to win the league this year.' },
  { speaker: 'Kyle Teichmann', text: 'AJ, third. 7.3% chance to win it all.' },
  { speaker: 'Kyle Teichmann', text: 'He doesn\'t just want to win. He wants to win and start a crazy quarterback.' },
  { speaker: 'Kyle Teichmann', text: 'Ryan, fix the website. You have AJ as a one-time champ.' },
  { speaker: 'AJ Krow', text: 'With where Teich has me, I think it\'s reasonable. Top three, four.' },
  { speaker: 'AJ Krow', text: 'We don\'t live in the middle. We are always going to be a high-variance ball club.' },
  { speaker: 'AJ Krow', text: 'I could have just started Trevor Lawrence. I would have won a championship.' },
  { speaker: 'AJ Krow', text: 'After you have two titles it\'s not just about winning a third. It\'s about how do I win it.' },
  { speaker: 'AJ Krow', text: 'Let\'s see how we do with Quinn Ewers. One hand behind my back. I thought the answer was almost yes.' },
  { speaker: 'AJ Krow', text: 'We only got a couple more left. Obviously we got Teich and Anna.' },
  { speaker: 'Kyle Teichmann', text: 'We\'re talking phenoms today. 20.99% chance to win.' },
  { speaker: 'Kyle Teichmann', text: 'We know Anna\'s got three. Nobody\'s ever gone back-to-back-to-back.' },
  { speaker: 'Kyle Teichmann', text: 'We think she should get to choose her draft slot.' },
  { speaker: 'Kyle Teichmann', text: 'That\'s why we\'re showing them so much respect with the two slot.' },
  { speaker: 'AJ Krow', text: 'Ignore me at your own peril. I have nothing else left to say. The data does the talking.' },
  { speaker: 'Kyle Teichmann', text: 'Also, do you think I would make all these videos and not put myself one?' },
  { speaker: 'Kyle Teichmann', text: 'The model gives us a 50.01% chance of winning the league.' },
  { speaker: 'Kyle Teichmann', text: 'We even think if we do what we\'re supposed to, we could win every weekly high.' },
  { speaker: 'Kyle Teichmann', text: 'I am the league.' },
  { speaker: 'AJ Krow', text: 'No surprise here that Ty would go with himself number one. I would have done the same thing.' },
  { speaker: 'AJ Krow', text: 'Pretty clear there\'s a bias in Teich\'s model.' },
  { speaker: 'AJ Krow', text: 'I don\'t think Ty has been a villain in this league for years.' },
];

export function publishedRanks() {
  return TAPE_RANKS.slice().sort((a, b) => a.rank - b.rank);
}

export function ranksFromLast() {
  return TAPE_RANKS.slice().sort((a, b) => b.rank - a.rank);
}

export function getTapeRank(rank) {
  return TAPE_RANKS.find((entry) => entry.rank === rank) || null;
}
